export enum AppRoutesConfig {
  Main = '/',
  Dashboard = '/dashboard',
  Services = '/services',
  Itsm = '/itsm',
  Statistics = '/statistics',
  Topology = '/topology',
}
